function featured_slider() {
      var swiper = new Swiper(".mySwiper", {
      slidesPerView: "auto",
      spaceBetween: 8,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
       navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
       breakpoints: {
      620: {
        slidesPerView: "auto",
        spaceBetween: 12,
      }
    },
    });
}
  function equalHeight(resize) {
    var elements = document.querySelectorAll(".swiper-wrapper.product-grid .full-unstyled-link"),
        allHeights = [],
        i = 0;
    if(resize === true){
      for(i = 0; i < elements.length; i++){
        elements[i].style.height = 'auto';
      }
    }
    for(i = 0; i < elements.length; i++){
      var elementHeight = elements[i].clientHeight;
      allHeights.push(elementHeight);
    }
    for(i = 0; i < elements.length; i++){
      elements[i].style.height = Math.max.apply( Math, allHeights) + 'px';
      if(resize === false){
        elements[i].className = elements[i].className + " show";
      }
    }
  }

  function load_cart(){
    fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
    .then((response) => response.text())
    .then((responseText) => {
      const cartid = 'cart-drawer';
      const html = new DOMParser().parseFromString(responseText, 'text/html')  
      const destination = document.querySelector('.cart-sidebar');
      const source = html.getElementById(cartid);
      if (source && destination) destination.innerHTML = source.innerHTML;
      document.querySelectorAll('.item-remove').forEach(function(cartRemove){
        var data_line = cartRemove.dataset.line;      
        cartRemove.addEventListener('click',(evt) => removeItem(data_line));
      });
      document.querySelectorAll('.header__icon--cart').forEach(function(cartButton){
        cartButton.addEventListener('click',function(e){
          document.querySelector('body').classList.add('open-drawer');
          document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
          console.log("added");
        });
      });
      
      window.addEventListener('load', function(event){
        var docWidth = document.documentElement.clientWidth;      
        featured_slider();
        
        setTimeout(function() {
          console.log("hello");
          (function () {
            equalHeight(true);
          })();
          window.onresize = function(){
            equalHeight(true);
          }
        }, 500);
      });
      
      document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
        cartButton.addEventListener('click',function(e){
          document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter');
        });
      });

      /*----- Remove Vaccine Product ----*/

      var cartItems = document.querySelectorAll('.wrapper-cart__item'); 
      cartItems.forEach(function(item){
        if(item.hasAttribute('data-vaccine-item')){
          var removeIdx = Number(item.getAttribute('data-index'));
          removeItem(removeIdx)
          console.log("removeItem Idx", removeIdx);
        }
      }); 
      
      const url = '/cart.js';
      fetch(url)
      .then((resp) => resp.json())
      .then(function(data) {
        var cart_count = data.item_count;
        if(document.querySelector('.cart-count-bubble') != null && cart_count > 0){
          document.querySelector('.cart-count-bubble span:first-child').innerHTML = cart_count;
        }else{
          document.querySelector('.cart-count-bubble span:first-child').innerHTML = 0;
        }
        
        /*if(document.querySelector('.cart-count-bubble') != null && cart_count > 0){
        	document.querySelector('.cart-count-bubble').querySelectorAll('[aria-hidden]')[0].innerHTML = cart_count;
        }else{
        	document.querySelector('.cart-count-bubble').querySelectorAll('[aria-hidden]')[0].innerHTML = 0;
        }*/
      })
      .catch(function(error) {
        console.log(error);
      })
    });
  }

load_cart();

function removeItem(data_line){
  const data = {'line': data_line ,'quantity': 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    load_cart();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  featured_slider();
}


function updateQuantity(data_index, data_qty) {
	
  var upId = data_index;
  var upQTY = data_qty;
  console.log("upId", upId, "----", "upQTY", upQTY);
  updateCartItem(upId, upQTY)	
  
  async function updateCartItem(id, qty) {
    const result = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: id,
        quantity: qty
      })
    })
    .then((data) => {
      if(data.status === 200){
        load_cart();
        console.log("updateQuantity Done");
      }else{
        console.log('Cart drawer quantity is not updated.');
      }
    })
    .catch((error) => {
      console.error('Error:', error);    
    });
  }
  setTimeout(function() {
    //console.log("helloooooo");
    featured_slider();
    (function () {
      equalHeight(true);
    })();
  }, 1500);
}

function custom_addtocart(variantsId) {
  
  //console.log("Clicked");
	//console.log(variantsId);
  var pbTempId = Number(variantsId);
  var pbTempQTY = 1;
  addItem(pbTempId, pbTempQTY)

  async function addItem(variantId, quantity) {
    const result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then((data) => {
      if(data.status === 200){  
        load_cart();
        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
      }else{
        console.log('cart-drawer error');
      }
    });
  }

}


function swymCallbackFn() {
  // your API calls go here
  //over ride the swym cart api to support custom slider cart 
  var replayAddToCartOriginalFn = _swat.replayAddToCart;
  window._swat.replayAddToCart = function() {
    //save the successCallback
    var successCallbackFn = arguments[2];
    arguments[2] = function(data) {
      if (successCallbackFn && updateThirdPartyCartFn) {
        successCallbackFn(data);
        updateThirdPartyCartFn(data);
      };
    }
    //call the orginal fn
    replayAddToCartOriginalFn.apply(this, arguments);
  };
  //runs on success callback.
  function updateThirdPartyCartFn(productData) {
    // Successfully added to cart API, Now call your slider cart here.
    load_cart();
    document.querySelector('body').classList.add('open-drawer');
    document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
    featured_slider();
    //console.log("Trigger your cart update here ");
    //console.log(" you can also append data to your custom cart using this API", "https://shopify.dev/docs/themes/ajax-api");
    
  }
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);


